import { translate } from '@/utils/translations'

import AccessibilityFeatures from '../../../Accessibility'
import Section from '../Section'

const SECTION_KEY = 'accessibility'

const AccessibilityFeaturesSection = () => (
  <Section
    condition
    eventKey={SECTION_KEY}
    title={translate('product_display.accessibility.accessibility')}
  >
    <AccessibilityFeatures />
  </Section>
)

export default AccessibilityFeaturesSection
